/**
 * Trazas de cache / coalescing en fetches compartidos (flags, branches, entitlements, support).
 * Por defecto consola limpia. Para depurar: EXPO_PUBLIC_DEBUG_SERVICE_FETCHES=1
 */
export function isDebugServiceFetches(): boolean {
  try {
    return typeof process !== 'undefined' && process.env?.EXPO_PUBLIC_DEBUG_SERVICE_FETCHES === '1';
  } catch {
    return false;
  }
}

export function debugServiceFetchWarn(...args: unknown[]): void {
  if (!__DEV__ || !isDebugServiceFetches()) return;
  console.debug(...args);
}
